import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { track } from "@/lib/analytics";

// Accessible FAQ accordion. `emitSchema` adds FAQPage JSON-LD only when the
// FAQs are visibly rendered on the page.
export default function FAQAccordion({ items, emitSchema = false }) {
  return (
    <div data-testid="faq-accordion">
      <Accordion type="single" collapsible className="w-full">
        {items.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="border-b border-border-neutral"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              onClick={() => track("faq_opened", { question: item.q })}
              className="text-left text-base md:text-lg font-bold text-forest hover:no-underline py-6"
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-mid-neutral text-base leading-relaxed pb-6">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {emitSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: items.map((it) => ({
                "@type": "Question",
                name: it.q,
                acceptedAnswer: { "@type": "Answer", text: it.a },
              })),
            }),
          }}
        />
      )}
    </div>
  );
}
